import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { UserService, isReadAllOnly } from '../services/user.service';

// Sends a read-all-only user from the Reports routes to their files, so a
// bookmarked report URL doesn't end on /access-denied. Anyone else, or a
// failed /api/me (the API's own 403 handling takes over), passes through.
export const reportsAccessGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.currentUser().pipe(
    map((user) => (isReadAllOnly(user) ? router.createUrlTree(['/']) : true)),
    catchError(() => of(true)),
  );
};
